import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { EmailTemplateContentValidationErrorEnum } from "../enums/EmailTemplateContentValidationErrorEnum";
import { formatRTEHtmlValue } from "../../utils/formatRTEHtmlValue";
import { TemplateContent } from "@pulse/pulse-rpcs/lib/email-cycle/templateContent";
import { EMPTY_CHARACTER } from "@pulse/shared-components";
import {
  createRTEFileServiceModel,
  RTEFileServiceModel,
} from "../../projects/models/RTEFileServiceModel";

const validateAndGetEmailTemplateContentValidationError = (
  templateContent: string,
): EmailTemplateContentValidationErrorEnum | undefined => {
  if (templateContent.length < TemplateContent.constraints.content.minSize) {
    return EmailTemplateContentValidationErrorEnum.MinSize;
  }

  if (templateContent.length > TemplateContent.constraints.content.maxSize) {
    return EmailTemplateContentValidationErrorEnum.MaxSize;
  }
};

export const EmailTemplateContentModel = types
  .model("EmailTemplateContentModel", {
    content: types.string,
    rteFileService: RTEFileServiceModel,
    validationError: types.maybe(
      types.enumeration(
        "EmailTemplateContentValidationError",
        Object.values(EmailTemplateContentValidationErrorEnum),
      ),
    ),
  })
  .views((store) => ({
    get rpcObject(): TemplateContent {
      return new TemplateContent(store.content);
    },
  }))
  .actions((store) => ({
    setContent: (content: SnapshotIn<typeof store>["content"]): void => {
      const formattedContent = formatRTEHtmlValue(content);
      store.validationError =
        validateAndGetEmailTemplateContentValidationError(formattedContent);
      store.content = formatRTEHtmlValue(formattedContent);
    },
  }));

export const createEmailTemplateContentModel = (
  emailTemplateContent?: SnapshotIn<typeof EmailTemplateContentModel>,
): Instance<typeof EmailTemplateContentModel> =>
  EmailTemplateContentModel.create(
    emailTemplateContent ?? {
      content: EMPTY_CHARACTER,
      rteFileService: createRTEFileServiceModel(),
    },
  );
